import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl } from "../api";
import { Container, Paper } from "@mui/material";

const GenerateSpeech = () => {
  // ========== State for courses / lessons ==========
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [lessons, setLessons] = useState([]);
  const [selectedLesson, setSelectedLesson] = useState(null);

  // ========== State for voices ==========
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState("");

  // ========== State for conversion status ==========
  const [conversionStatus, setConversionStatus] = useState("");

  // ================== Fetch courses and voices on mount ==================
  useEffect(() => {
    fetchCourses();
    fetchVoices();
  }, []);

  // ================== Fetch Data ==================
  const fetchCourses = async () => {
    try {
      const response = await axios.get(`${baseUrl}/courses/`);
      setCourses(response.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const fetchLessons = async (courseId) => {
    try {
      const response = await axios.get(`${baseUrl}/courses/${courseId}`);
      setLessons(response.data.lessons);
    } catch (error) {
      console.error("Error fetching lessons:", error);
    }
  };

  const fetchVoices = async () => {
    try {
      const response = await axios.get(`${baseUrl}/voices/`);
      setVoices(response.data);
    } catch (error) {
      console.error("Error fetching voices:", error);
    }
  };

  // ================== Handlers ==================
  const handleCourseChange = (e) => {
    const courseId = e.target.value;
    setSelectedCourse(courseId);
    fetchLessons(courseId);
  };

  const handleLessonChange = (e) => {
    const lessonId = e.target.value;
    setSelectedLesson(lessonId);
  };

  const handleVoiceChange = (e) => {
    setSelectedVoice(e.target.value);
  };

  const generateSpeech = async () => {
    if (!selectedLesson) {
      alert("Please select a lesson.");
      return;
    }
    if (!selectedVoice) {
      alert("Please select a voice.");
      return;
    }
    setConversionStatus("Generating speech...");
    try {
      // Call the API to generate speech.
      // This example assumes an endpoint that accepts lessonId and voice.
      const response = await axios.post(`${baseUrl}/generate-speech`, {
        lessonId: selectedLesson,
        voice: selectedVoice,
      });
      setConversionStatus(response.data.message || "Speech generation started.");
    } catch (error) {
      console.error("Error generating speech:", error);
      setConversionStatus("Error generating speech.");
    }
  };

  // ================== Render UI ==================
  return (
    <Container maxWidth="lg">
      <Paper elevation={3} sx={{ p: 4 }}>
        <h1 style={styles.header}>Speech Generation</h1>

        {/* Course Selection */}
        <div style={styles.selectContainer}>
          <label style={styles.label}>Select Course:</label>
          <select
            onChange={handleCourseChange}
            value={selectedCourse || ""}
            style={styles.select}
          >
            <option value="">--Select a Course--</option>
            {courses.map((course) => (
              <option key={course.id} value={course.id}>
                {course.subject}
              </option>
            ))}
          </select>
        </div>

        {/* Lesson Selection */}
        <div style={styles.selectContainer}>
          <label style={styles.label}>Select Lesson:</label>
          <select
            onChange={handleLessonChange}
            value={selectedLesson || ""}
            style={styles.select}
          >
            <option value="">--Select a Lesson--</option>
            {lessons.map((lesson) => (
              <option key={lesson.id} value={lesson.id}>
                {lesson.title}
              </option>
            ))}
          </select>
        </div>

        {/* Voice Selection */}
        <div style={styles.selectContainer}>
          <label style={styles.label}>Select Cloned Voice:</label>
          <select
            onChange={handleVoiceChange}
            value={selectedVoice || ""}
            style={styles.select}
          >
            <option value="">--Select a Voice--</option>
            {voices.map((voice) => (
              <option key={voice.id} value={voice.id}>
                {voice.name}
              </option>
            ))}
          </select>
        </div>

        {/* Generate Speech Button */}
        <div style={styles.buttonContainer}>
          <button onClick={generateSpeech} style={styles.button}>
            Generate Speech
          </button>
        </div>

        {/* Conversion Status */}
        <div style={styles.statusContainer}>
          <label style={styles.label}>Status:</label>
          <span>{conversionStatus}</span>
        </div>
      </Paper>
    </Container>
  );
};

/** ========== Basic CSS Styles ========== */
const styles = {
  header: {
    textAlign: "center",
    fontSize: "26px",
    marginBottom: "20px",
  },
  selectContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
  },
  label: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  select: {
    width: "100%",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  buttonContainer: {
    display: "flex",
    gap: "10px",
    marginBottom: "10px",
  },
  button: {
    padding: "10px",
    backgroundColor: "#007BFF",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  statusContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "20px",
  },
};

export default GenerateSpeech;
